import contentEditableDivSchema from './contentEditableDivSchema';
import unorderedList from './unorderedList';
import listItem from './listItem';

export default (params) => {
  const { preTag } = params;

  return {
    blocks: {
      [`${preTag}`]: contentEditableDivSchema,
      unordered_list: unorderedList,
      list_item: listItem,
      paragraph: {
        nodes: [
          {
            match: { object: 'text' },
          },
        ],
      },
    },
  };
};
